<script>
import { defineComponent } from 'vue'
import InlineSvg from 'vue-inline-svg'

export default defineComponent({
  name: 'EmptyItems',
  components: { InlineSvg },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    }
  }
})
</script>

<template>
  <div class="empty-items-wrapper">
    <inline-svg fill="currentColor" height="100" :src="require('@/assets/img/img_helper_empty.svg')"/>
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
  </div>
</template>

<style lang="less" scoped>
  .empty-items-wrapper {
    display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;

    h3 {
      margin-top: 15px;
      font-weight: 600;
      font-size: 1.2em;
    }
  }
</style>
